export default __webpack_public_path__ + "static/media/Sidebar-banner.f2d4bdbd.png";